let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gt5IT")).then(() => parcelRequire('gwfIx'));